export default {
  'app.settings.menuMap.basic': 'Основные настройки',
  'app.settings.menuMap.security': 'Настройки безопасности',
  'app.settings.menuMap.binding': 'Привязка аккаунта',
  'app.settings.menuMap.notification': 'Уведомления о новых сообщениях',
  'app.settings.basic.avatar': 'Аватар',
  'app.settings.basic.change-avatar': 'Изменить аватар',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Пожалуйста, введите ваш email!',
  'app.settings.basic.nickname': 'Псевдоним',
  'app.settings.basic.nickname-message': 'Пожалуйста, введите ваш псевдоним!',
  'app.settings.basic.profile': 'Личный профиль',
  'app.settings.basic.profile-message': 'Пожалуйста, введите ваш личный профиль!',
  'app.settings.basic.profile-placeholder': 'Краткое представление о себе',
  'app.settings.basic.country': 'Страна/Регион',
  'app.settings.basic.country-message': 'Пожалуйста, введите вашу страну!',
  'app.settings.basic.geographic': 'Область или город',
  'app.settings.basic.geographic-message': 'Пожалуйста, введите вашу географическую информацию!',
  'app.settings.basic.address': 'Адрес улицы',
  'app.settings.basic.address-message': 'Пожалуйста, введите ваш адрес!',
  'app.settings.basic.phone': 'Номер телефона',
  'app.settings.basic.phone-message': 'Пожалуйста, введите ваш телефон!',
  'app.settings.basic.update': 'Обновить информацию',
  'app.settings.security.strong': 'Сильный',
  'app.settings.security.medium': 'Средний',
  'app.settings.security.weak': 'Слабый',
  'app.settings.security.password': 'Пароль аккаунта',
  'app.settings.security.password-description': 'Текущая сила пароля',
  'app.settings.security.phone': 'Телефон безопасности',
  'app.settings.security.phone-description': 'Привязанный телефон',
  'app.settings.security.question': 'Вопрос безопасности',
  'app.settings.security.question-description':
    'Вопрос безопасности не установлен, политика безопасности может эффективно защитить безопасность аккаунта',
  'app.settings.security.email': 'Резервный Email',
  'app.settings.security.email-description': 'Привязанный Email',
  'app.settings.security.mfa': 'Устройство MFA',
  'app.settings.security.mfa-description':
    'Устройство MFA не привязано, после привязки может быть подтверждено дважды',
  'app.settings.security.modify': 'Изменить',
  'app.settings.security.set': 'Установить',
  'app.settings.security.bind': 'Привязать',
  'app.settings.binding.taobao': 'Привязка Taobao',
  'app.settings.binding.taobao-description': 'В настоящее время аккаунт Taobao не привязан',
  'app.settings.binding.alipay': 'Привязка Alipay',
  'app.settings.binding.alipay-description': 'В настоящее время аккаунт Alipay не привязан',
  'app.settings.binding.dingding': 'Привязка DingTalk',
  'app.settings.binding.dingding-description':
    'В настоящее время аккаунт DingTalk не привязан',
  'app.settings.binding.bind': 'Привязать',
  'app.settings.notification.password': 'Пароль аккаунта',
  'app.settings.notification.password-description':
    'Сообщения от других пользователей будут уведомляться в виде станционного письма',
  'app.settings.notification.messages': 'Системные сообщения',
  'app.settings.notification.messages-description':
    'Системные сообщения будут уведомляться в виде станционного письма',
  'app.settings.notification.todo': 'Уведомления о задачах',
  'app.settings.notification.todo-description':
    'Список задач будет уведомляться в виде письма со станции',
  'app.settings.open': 'Открыть',
  'app.settings.close': 'Закрыть',
};